import { render, staticRenderFns } from "./CustomFormInput.vue?vue&type=template&id=560a9596&scoped=true"
import script from "./CustomFormInput.vue?vue&type=script&lang=js"
export * from "./CustomFormInput.vue?vue&type=script&lang=js"
import style0 from "./CustomFormInput.vue?vue&type=style&index=0&id=560a9596&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a9596",
  null
  
)

export default component.exports